/**
 * Flow (klantportaal) per omgeving. Zelfde keuze als de contentkalender-ingang:
 * test en lokaal → test.flow, al het andere (intern.fullframe.nl) → productie.
 */
export function flowBasis(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const testOfLokaal = hostname === 'test.fullframe.nl' || hostname === 'localhost' || hostname === '127.0.0.1';
  return testOfLokaal ? 'https://test.flow.fullframe.nl' : 'https://flow.fullframe.nl';
}

export const flowUrl = (pad = '') => `${flowBasis()}${pad}`;

/** Formaat omzetten (reframe 9:16/4:5/1:1) woont in Flow; medewerkers werken via het Full Frame-account. */
export const FORMAAT_OMZETTEN_URL = flowUrl('/formaat');
